<template>
  <el-container class="dashboard-container">
    <!-- سایدبار -->
    <Sidebar ref="sidebarRef" />

    <!-- بخش اصلی -->
    <el-container direction="vertical" class="main-container">
      <!-- هدر موبایل -->
      <el-header v-if="isMobile" class="mobile-header">
        <el-button @click="sidebarRef?.toggleSidebar()" circle plain>
          <el-icon><Menu /></el-icon>
        </el-button>
      </el-header>

      <!-- محتوای اصلی -->
      <el-main style="direction: rtl">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import Sidebar from "@/components/SideBar.vue";
import { Menu } from "@element-plus/icons-vue";

const sidebarRef = ref(null);
const isMobile = ref(false);
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768;
};
onMounted(() => {
  window.addEventListener("resize", checkMobile);
  checkMobile();
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", checkMobile);
});
</script>

<style scoped>
.mobile-header {
  background-color: #205685;
  color: white;
  display: flex;
  align-items: center;
  height: 60px;
  direction: rtl;
}
</style>
